import { type FormNumberInputProps, FormNumberInput, Text } from '@shared/components';

export type FormPercentageInputProps = {
  name: string;
  textAlign?: 'left' | 'center' | 'right';
} & Pick<FormNumberInputProps, 'onChange' | 'disabled'>;

export default function FormPercentageInput(props: Readonly<FormPercentageInputProps>) {
  const { name, onChange, textAlign = 'center', disabled: isDisabled } = props;

  return (
    <FormNumberInput
      name={name}
      placeholder='0'
      min={0}
      max={100}
      onChange={onChange}
      disabled={isDisabled}
      slotProps={{
        input: {
          sx: (theme) => ({
            // Use to force MUI for NOT create padding when endAdornment got some contents
            pr: theme.spacing(0),
          }),
          endAdornment: (
            <Text
              sx={(theme) => ({
                position: 'absolute',
                right: theme.spacing(2),
                color: theme.palette.grey[500],
              })}
            >
              %
            </Text>
          ),
        },
        htmlInput: {
          sx: (theme) => ({
            ...theme.typography.body1Semibold,
            p: theme.spacing(2),
            minHeight: '32px', // Use minHeight because an MUI default value for minHeight is 42px
            textAlign: textAlign,
          }),
        },
      }}
    />
  );
}
